let lastScrollTop = 0; // 最後にスクロールした位置
let mobileMenuBar = document.querySelector('.mobile-menu-bar'); // メニューバーの要素を取得

if (mobileMenuBar) {
  window.addEventListener('scroll', function() {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop; // 現在のスクロール位置を取得

    // スクロール位置が上に行ったとき（スクロールアップ）にメニューを表示
    if (currentScroll > lastScrollTop) {
      // スクロールダウン時、メニューを隠す
      mobileMenuBar.style.bottom = '-100px'; // メニューを隠す（100px分下に移動）
    } else {
      // スクロールアップ時、メニューを表示
      mobileMenuBar.style.bottom = '0'; // メニューを表示
    }

    // 最後のスクロール位置を更新
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // 負の値にしない
  });
}
